import React from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const accountLinks = [
    { href: "/account-page", label: "Dashboard" },
    { href: "/account-orders", label: "My Orders" },
    { href: "/account-details", label: "Account Details" },
    // { href: "/account-addresses", label: "Addresses" },
];

export default function Sidebar() {
    const { pathname } = useLocation();
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/"); // Ana sayfaya yönlendir
    };

    return (
        <>
            {accountLinks.map(({ href, label }) => (
                <li key={href}>
                    <Link
                        to={href}
                        className={`text-sm link fw-medium my-account-nav-item ${
                            pathname == href ? "active" : ""
                        }`}
                    >
                        {label}
                    </Link>
                </li>
            ))}
            <li>
                <Link onClick={handleLogout} className="text-sm link fw-medium my-account-nav-item">
                    Log Out
                </Link>
            </li>
        </>
    );
}
